(function () {
  "use strict";

  var t = {
    61: function _(t, e, r) {
      var _n,
          o = this && this.__extends || (_n = function n(t, e) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        })(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function r() {
          this.constructor = t;
        }

        _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          i = this && this.__assign || function () {
        return (i = Object.assign || function (t) {
          for (var e, r = 1, n = arguments.length; r < n; r++) {
            for (var o in e = arguments[r]) {
              Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
            }
          }

          return t;
        }).apply(this, arguments);
      },
          s = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (o, i) {
          function s(t) {
            try {
              u(n.next(t));
            } catch (t) {
              i(t);
            }
          }

          function a(t) {
            try {
              u(n.throw(t));
            } catch (t) {
              i(t);
            }
          }

          function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(s, a);
          }

          u((n = n.apply(t, e || [])).next());
        });
      },
          a = this && this.__generator || function (t, e) {
        var r,
            n,
            o,
            i,
            s = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;

        function a(i) {
          return function (a) {
            return function (i) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; s;) {
                try {
                  if (r = 1, n && (o = 2 & i[0] ? n.return : i[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, i[1])).done) return o;

                  switch (n = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                    case 0:
                    case 1:
                      o = i;
                      break;

                    case 4:
                      return s.label++, {
                        value: i[1],
                        done: !1
                      };

                    case 5:
                      s.label++, n = i[1], i = [0];
                      continue;

                    case 7:
                      i = s.ops.pop(), s.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = s.trys).length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                        s = 0;
                        continue;
                      }

                      if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                        s.label = i[1];
                        break;
                      }

                      if (6 === i[0] && s.label < o[1]) {
                        s.label = o[1], o = i;
                        break;
                      }

                      if (o && s.label < o[2]) {
                        s.label = o[2], s.ops.push(i);
                        break;
                      }

                      o[2] && s.ops.pop(), s.trys.pop();
                      continue;
                  }

                  i = e.call(t, s);
                } catch (t) {
                  i = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var u = r(253),
          c = r(275),
          l = r(463),
          p = r(280),
          f = r(804),
          d = function (t) {
        function e(e) {
          var r = t.call(this, e) || this;
          return r._batchAxios = new u.NodeProvider({
            baseURL: e.batchUrl,
            responseType: "text",
            transformResponse: void 0
          }), r;
        }

        return o(e, t), e.prototype.getUnspentTransactions = function (t) {
          return s(this, void 0, void 0, function () {
            var e, r, n;
            return a(this, function (o) {
              switch (o.label) {
                case 0:
                  return e = t.map(l.addressToString), [4, this._batchAxios.nodePost("/addresses/utxo", {
                    addresses: f.uniq(e)
                  })];

                case 1:
                  return r = o.sent(), n = r.map(function (t) {
                    var e = t.address;
                    return t.utxo.map(function (t) {
                      return i(i({}, t), {
                        address: e,
                        satoshis: t.value,
                        amount: new c.BigNumber(t.value).dividedBy(1e8).toNumber(),
                        blockHeight: t.status.block_height
                      });
                    });
                  }), [2, f.flatten(n)];
              }
            });
          });
        }, e.prototype.getAddressTransactionCounts = function (t) {
          return s(this, void 0, void 0, function () {
            var e;
            return a(this, function (r) {
              switch (r.label) {
                case 0:
                  return e = t.map(l.addressToString), [4, this._batchAxios.nodePost("/addresses", {
                    addresses: f.uniq(e)
                  })];

                case 1:
                  return [2, r.sent().reduce(function (t, e) {
                    return t[e.address] = e.chain_stats.tx_count + e.mempool_stats.tx_count, t;
                  }, {})];
              }
            });
          });
        }, e;
      }(p.BitcoinEsploraApiProvider);

      e.default = d;
    },
    175: function _(t, e, r) {
      var n = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.BitcoinEsploraBatchApiProvider = void 0;
      var o = n(r(61));
      e.BitcoinEsploraBatchApiProvider = o.default;
    },
    280: function _(t) {
      t.exports = require("@liquality/bitcoin-esplora-api-provider");
    },
    253: function _(t) {
      t.exports = require("@liquality/node-provider");
    },
    275: function _(t) {
      t.exports = require("@liquality/types");
    },
    463: function _(t) {
      t.exports = require("@liquality/utils");
    },
    804: function _(t) {
      t.exports = require("lodash");
    }
  },
      e = {},
      r = function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var i = e[n] = {
      exports: {}
    };
    return t[n].call(i.exports, i, i.exports, r), i.exports;
  }(175);

  module.exports = r;
})();